import { render, staticRenderFns } from "./ImagesetItem.vue?vue&type=template&id=0bda7432&scoped=true&"
import script from "./ImagesetItem.vue?vue&type=script&lang=ts&"
export * from "./ImagesetItem.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesetItem.vue?vue&type=style&index=0&id=0bda7432&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda7432",
  null
  
)

export default component.exports